'use client';

import {config} from '@/config';
import {LoaderContext} from '@/context/LoaderContext';
import * as userSessionRepo from '@/repositories/user-session-repo';
import {useRouter} from 'next/navigation';
import {useContext, useEffect} from 'react';

/**
 * References:
 * - https://docs.aws.amazon.com/cognito/latest/developerguide/logout-endpoint.html
 */

export default function Home() {
  const router = useRouter();
  const loader = useContext(LoaderContext);

  useEffect(() => {
    loader.showLoader('Logging out...');
    const appUrl = config.appUrl();

    const params = new URLSearchParams({
      client_id: config.cognitoClientId,
      logout_uri: appUrl.match(/\/$/) ? appUrl : `${appUrl}/`,
    });
    const COGNITO_LOGOUT_URL = `${config.cognitoDomain}/logout?${params}`;

    userSessionRepo.logOut();

    // clear PKCE values
    localStorage.removeItem('code_challenge');
    localStorage.removeItem('code_verifier');

    // Redirect to sign out of Cognito.
    router.push(COGNITO_LOGOUT_URL);
  });

  return <></>;
}
